var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43.2012,
    r: 42.5,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2817_4771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8163 38.6753L44.6436 22.3642L44.065 21.9664L42.9869 21.7012L41.8035 22.0194L42.4083 23.2129L41.5668 22.2051L25.1837 38.6753C24.7367 39.1261 24.5 39.7096 24.5 40.3461C24.5 40.9827 24.7367 41.5927 25.1837 42.0435C26.1041 42.9718 27.6031 42.9718 28.5235 42.0435L40.6464 29.8169V63.3407C40.6464 64.6403 41.6983 65.7277 43.0131 65.7277C44.328 65.7277 45.3799 64.6668 45.3799 63.3407V29.8169L57.5028 42.0435C57.9499 42.4944 58.5284 42.7331 59.1596 42.7331C59.817 42.7331 60.3692 42.4944 60.8426 42.0435C61.7367 41.1153 61.7367 39.6035 60.8163 38.6753Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2817_4771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 44,
    fill: "white",
    transform: "translate(24.5 21.7012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.956e490b3b11b211f366e8e22f2019eb.svg";
export { ForwardRef as ReactComponent };